export interface AuditLogSearchCriteria {
    updatedDateFrom: Date | null,
    updatedDateTo: Date | null,
    opsLines: string[] | null,
    cntrNos: string[],
    forwarderCodes: string[] | null,
    billOfLading: string | null,
    shippingBill: string | null,
    userId: string | null,
    auditLogIncident: string | null,
    proposalNo: string | null,
    auditLogType: string | null,

    [key: string]: string | number | null | undefined | Object
}

export const EMPTY_AUDIT_LOG_SEARCH_CRITERIA: AuditLogSearchCriteria = {
    updatedDateFrom: null,
    updatedDateTo: null,
    opsLines: [],
    cntrNos: [],
    forwarderCodes: [],
    billOfLading: null,
    shippingBill: null,
    userId: '',
    auditLogIncident: '',
    proposalNo: null,
    auditLogType: "Line Charge Related"
}

